const DEV_URL = 'http://localhost:5000'
const PRODUCTION_URL = 'https://fastycash-api.onrender.com'

const serviceConfig = {
    API_URL: process.env.NODE_ENV === 'development'
        ? DEV_URL
        : PRODUCTION_URL
}

export default serviceConfig